// extracted by mini-css-extract-plugin
export var banner = "_rp-0";
export var settingRow = "_rp-2";
export var titleIcon = "_rp-1";